export const BLOCKS = {
    'DOCUMENT': 'document',
    'PARAGRAPH': 'paragraph',
    'HEADING_1': 'heading-1',
    'HEADING_2': 'heading-2',
    'HEADING_3': 'heading-3',
    'HEADING_4': 'heading-4',
    'HEADING_5': 'heading-5',
    'HEADING_6': 'heading-6',
    'OL_LIST': 'ordered-list',
    'UL_LIST': 'unordered-list',
    'LIST_ITEM': 'list-item',
    'HR': 'hr',
    'QUOTE': 'blockquote',
    'EMBEDDED_ENTRY': 'embedded-entry-block',
    'EMBEDDED_ASSET': 'embedded-asset-block',
    'EMBEDDED_RESOURCE': 'embedded-resource-block',
    'TABLE': 'table',
    'TABLE_ROW': 'table-row',
    'TABLE_CELL': 'table-cell',
    'TABLE_HEADER_CELL': 'table-header-cell',
};

export const MARKS = {
    'BOLD': 'bold',
    'ITALIC': 'italic',
    'UNDERLINE': 'underline',
    'CODE': 'code',
    'SUPERSCRIPT': 'superscript',
    'SUBSCRIPT': 'subscript',
};

export const INLINES = {
    'HYPERLINK': 'hyperlink',
    'ENTRY_HYPERLINK': 'entry-hyperlink',
    'ASSET_HYPERLINK': 'asset-hyperlink',
    'RESOURCE_HYPERLINK': 'resource-hyperlink',
    'EMBEDDED_ENTRY': 'embedded-entry-inline',
    'EMBEDDED_RESOURCE': 'embedded-resource-inline',
};

export const helpers = {
    hasValue: (obj, value) => {
        for (let _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) { // eslint-disable-line no-underscore-dangle
            const key = _a[_i]; // eslint-disable-line no-underscore-dangle
            if (value === obj[key]) {
                return true;
            }
        }

        return false;
    },
    isInline: node => helpers.hasValue(INLINES, node.nodeType),
    isBlock: node => helpers.hasValue(BLOCKS, node.nodeType),
    isText: node => node.nodeType === 'text',
};

export default {
    BLOCKS,
    MARKS,
    INLINES,
    helpers,
};
